var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullets-toc"},[_c('div',{staticClass:"list-unstyled bullets-toc__list"},_vm._l((_vm.chartsWithAnchors),function(ref){
var id = ref.id;
var anchor = ref.anchor;
var title = ref.title;
return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(anchor),expression:"anchor"}],key:id,staticClass:"bullets-toc__list__item",attrs:{"href":"#"}},[_c('span',{staticClass:"bullets-toc__list__item__title"},[_vm._v(" "+_vm._s(title)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }